"use strict";var n=require("./hook.js");exports.styleSingleton=function(){var t=n.styleHookSingleton();return function(n){var e=n.styles,r=n.dynamic;return t(e,r),null}};
//# sourceMappingURL=component.js.map
